var map = {
	"./avvisi-01.png": 21,
	"./avvisi-02.png": 22,
	"./back-assicurazione.jpg": 23,
	"./back-avvisi.jpg": 24,
	"./back-chisiamo.jpg": 25,
	"./back-eventi.png": 26,
	"./back-news.jpg": 27,
	"./background-news.png": 28,
	"./bg-base-00.jpg": 29,
	"./bg-budrio-01.jpg": 30,
	"./bg-formazione-02.jpg": 31,
	"./bg-infortuni-04.jpg": 32,
	"./bg-news.jpg": 33,
	"./bg-superabile-03.jpg": 34,
	"./bg_hero.jpg": 35,
	"./card-avvisi.png": 36,
	"./card_01-hover.png": 37,
	"./card_01.png": 38,
	"./card_02-hover.png": 39,
	"./card_02.png": 40,
	"./card_03-hover.png": 41,
	"./card_03.png": 42,
	"./card_04-hover.png": 43,
	"./card_04.png": 44,
	"./chisiamo-text-01.png": 45,
	"./chisiamo-text-02.png": 46,
	"./comefareper-list.png": 47,
	"./comefareper-list2.png": 48,
	"./comefareper.png": 49,
	"./comefareper2.png": 50,
	"./eventi-01.png": 51,
	"./eventi-02.png": 52,
	"./favicon.ico": 53,
	"./footer.jpg": 54,
	"./h1-abstract.png": 55,
	"./h1.png": 56,
	"./header_01.png": 57,
	"./header_02.png": 58,
	"./hero-image.png": 59,
	"./hero.jpg": 60,
	"./home-events-02.png": 61,
	"./home-news-01-hover.png": 62,
	"./home-news-01.png": 63,
	"./home-news-02.png": 64,
	"./images-2.png": 65,
	"./infographic.jpg": 66,
	"./links.png": 67,
	"./loader.gif": 68,
	"./mega_01.jpg": 69,
	"./mega_02.jpg": 70,
	"./mega_03.jpg": 71,
	"./mega_04.jpg": 72,
	"./nav_default_foglia.png": 73,
	"./news-01.png": 74,
	"./news-02.png": 75,
	"./news-nav.png": 76,
	"./primo-piano.png": 77,
	"./quote.png": 78,
	"./table.png": 79,
	"./text-01.png": 80,
	"./text-02.png": 81,
	"./text-03.png": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;